"use client";

import React from "react";
import { Smartphone, BatteryCharging, Droplet, Activity, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Desbrossament",
  description: "Neteja professional de parcel·les i terrenys amb maquinària especialitzada per a la prevenció d'incendis.",
  icon: Smartphone,
  highlight: false,
  link: "/ContactPage"
}, {
  title: "Poda Professional",
  description: "Manteniment d'arbrat i arbustos amb tècniques respectuoses per garantir la salut de la vegetació.",
  icon: BatteryCharging,
  highlight: false,
  link: "/ContactPage"
}, {
  title: "Manteniment de Camins",
  description: "Reparació i conservació de vials rurals i accessos privats per garantir una circulació segura.",
  icon: Droplet,
  highlight: false,
  link: "/ContactPage"
}, {
  title: "Gestió de Finques",
  description: "Servei integral de manteniment rural adaptat a les necessitats específiques de cada propietat.",
  icon: Activity,
  highlight: true,
  link: "/ContactPage"
}];
export default function OurExpertRepairServices() {
  const {
    headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}